module.exports = __webpack_public_path__ + "static/dcrmLogin-aa91d6453cffae3048a3ca5273444290.svg";